import React, { useContext, useRef, useEffect } from 'react';
import { NavbarContext } from './NavbarContext.js';
import { useFocusManager as $9bf71ea28793e738$export$10c5169755ce7bd7 } from '../../../../../../node_modules/@react-aria/focus/dist/FocusScope.mjs.js';

var NavbarMobileNotifications = function NavbarMobileNotifications() {
  var _useContext = useContext(NavbarContext),
      notificationMenuItems = _useContext.notificationMenuItems,
      notificationItemFormatter = _useContext.notificationItemFormatter,
      noNotificationMessage = _useContext.noNotificationMessage,
      notificationMenuLinkWrapper = _useContext.notificationMenuLinkWrapper;

  var focusManager = $9bf71ea28793e738$export$10c5169755ce7bd7();
  var notificationItems = useRef([]);

  var handleKeyDown = function handleKeyDown(e) {
    if (!focusManager) return;

    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusManager.focusNext({
          wrap: true
        });
        break;

      case 'ArrowUp':
        e.preventDefault();
        focusManager.focusPrevious({
          wrap: true
        });
        break;

      case 'End':
        e.preventDefault();
        focusManager.focusLast({});
        break;

      case 'Home':
        e.preventDefault();
        focusManager.focusFirst({});
        break;
    }
  };

  var optionalProps = function optionalProps(e) {
    var optionalProps = {};

    if (e && !e.querySelector('a')) {
      optionalProps.tabIndex = 0;
    }

    return optionalProps;
  };

  useEffect(function () {
    if (notificationItems.current[0]) {
      notificationItems.current[0].focus();
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("span", {
    className: 'helix-unified-navbar__panel-header'
  }, "Notifications"), notificationMenuItems && notificationMenuItems.length > 0 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
  notificationMenuItems.map(function (item, index) {
    return React.createElement("div", {
      key: "mobile-notification-item-".concat(index),
      className: 'helix-unified-navbar__mobile-menu-item'
    }, React.createElement("span", Object.assign({
      ref: function ref(_ref) {
        return notificationItems.current.push(_ref);
      },
      onKeyDown: function onKeyDown(e) {
        return handleKeyDown(e);
      },
      className: 'helix-unified-navbar__mobile-menu-notification-item'
    }, optionalProps(notificationItems.current[index])), notificationMenuLinkWrapper ? notificationMenuLinkWrapper({
      item: item,
      props: {}
    }) : notificationItemFormatter ? notificationItemFormatter(item) : item.label));
  }) : React.createElement("div", {
    className: 'empty-state'
  }, noNotificationMessage));
};

export { NavbarMobileNotifications as default };